var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label,"label-cols":"4","label-align":"right"}},[_c('b-form-select',{attrs:{"value":_vm.value,"options":_vm.options,"value-field":_vm.valueField,"text-field":_vm.textField,"state":_vm.valid,"size":"sm","disabled":_vm.disabled},on:{"change":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }